import { useTranslation } from 'react-i18next';
import { themeOptions } from './themeOptions';
import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from '@/Domain/components/Shared/DropdownMenu/DropdownMenu';
import { ThemeEnum } from '@/Domain/enum/Theme.enum';
import { useThemeStore } from '@/Domain/store/theme.store';

export function ThemeMenuItems() {
  const { t } = useTranslation('sidebar_menu');
  const theme = useThemeStore((state) => state.theme);
  const setTheme = useThemeStore((state) => state.setTheme);

  return (
    <DropdownMenuRadioGroup value={theme} onValueChange={(value) => setTheme(value as ThemeEnum)}>
      {themeOptions.map(({ icon: Icon, labelKey, value }) => (
        <DropdownMenuRadioItem key={value} value={value}>
          <div className="flex items-center gap-2">
            <Icon className="size-4" />
            <span>{t(labelKey)}</span>
          </div>
        </DropdownMenuRadioItem>
      ))}
    </DropdownMenuRadioGroup>
  );
}
